import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./style.css";
import PageContentOverView from "./PageContentOverView";
import PageContentDetails from "./PageContentDetails";
import { AiOutlineRight } from "react-icons/ai";
import { scrollx_animate_black } from "../../../assets/icons";

const PageContent = ({
  selectedHeading,
  openSubheadingId,
  toggleSubheading,
  currPageContent,
  tertiaryId,
  setTertiaryId,
  loadPageContent,
  secondaryHeading,
  tertiarySubHeading,
  mainHeading,
  headingClicked,
  setCurrPageContent,
}) => {
  const { id } = useParams();
  const subHeadingCount = selectedHeading?.subHeadings.length || 0;

  return (
    <div className="text-[#707070] h-full FontFamily-Avenir-reg">
      <div className="flex items-center h-[6%] w-full border-b border-[#e5e7ea] FontFamily-Avenir-reg">
        <div className="text-[13px] leading-5 tracking-wider pl-3 FontFamily-Avenir-reg">
          <h1>Help</h1>
        </div>
        <div className="px-2">
          <AiOutlineRight className="text-[#707070] text-base FontFamily-Avenir font-bold" size={16}/>
        </div>
        <div className="text-[13px] leading-5 tracking-wider FontFamily-Avenir w-fit">
          <h1 className="text-[#505256] cursor-pointer">{loadPageContent ? "" : mainHeading}</h1>
        </div>
      </div>

      { id ? (
        <PageContentDetails
          subHeadingCount={subHeadingCount}
          toggleSubheading={toggleSubheading}
          selectedHeading={selectedHeading}
          currPageContent={currPageContent}
          tertiaryId={tertiaryId}
          secondaryHeading={secondaryHeading}
          tertiarySubHeading={tertiarySubHeading}
          loadPageContent={loadPageContent}
          setCurrPageContent={setCurrPageContent}
        />
      ) 
      : (
        <PageContentOverView
          selectedHeading={selectedHeading}
          toggleSubheading={toggleSubheading}
          openSubheadingId={openSubheadingId}
          subHeadingCount={subHeadingCount}
          tertiaryId={tertiaryId}
          setTertiaryId={setTertiaryId}
        />
      )}

       
   
    </div>
  );
};

export default PageContent;
